import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionLandingPage } from "./actionLandingPage";
export var epicLandingPageLogoutRequest = function (action$) {
    return action$.pipe(ofType(TypeActionLandingPage.Logout), map(function () {
        return actionModalOpen(IdModal.LogoutConfirmation);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/epicLandingPageLogoutRequest.ts
// module id = 1983
// module chunks = 3